export function getTypeService(value: string) {
    switch (value) {
        case 'serviceOrder':
            return 'Ordem de Serviço';
        case 'budget':
            return 'Orçamento';
        default:
            return '';
    }
}